import { useState } from 'react'
import { Link } from 'react-router-dom'
import { allaBegrepp, begreppAO } from '../lib/begrepp'
import { useSidTitel } from '../lib/seo'
import { KURSNAMN } from '../lib/site'

/** A–Ö-översikt över läromedlets alla begrepp. Varje begrepp har en egen sida
 *  (/begrepp/<slug>) — översikten är ingången och filtret ett snabbt sätt att
 *  hitta rätt. Innehållet kommer rakt ur den gemensamma begreppsdatabasen. */
export default function BegreppOversikt() {
  useSidTitel('Begrepp A–Ö')
  const [filter, setFilter] = useState('')
  const soktext = filter.trim().toLowerCase()
  const grupper = begreppAO()
    .map((g) => ({
      ...g,
      poster: soktext ? g.poster.filter((p) => p.begrepp.toLowerCase().includes(soktext)) : g.poster,
    }))
    .filter((g) => g.poster.length > 0)

  return (
    <div className="wrap">
      <section className="hero">
        <span className="hero-etikett">Ordlista · {allaBegrepp.length} begrepp</span>
        <h1>Begrepp A–Ö</h1>
        <p>
          Alla begrepp i läromedlet {KURSNAMN}, med förklaringar hämtade ur kapitlens
          begreppslistor. Varje begrepp länkar till kapitlet där det hör hemma.
        </p>
        <input
          type="search"
          className="begrepp-filter no-print"
          placeholder="Sök begrepp …"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          aria-label="Filtrera begreppslistan"
        />
      </section>

      {grupper.length === 0 && <p className="sektionsingress">Inga begrepp matchar ”{filter.trim()}”.</p>}

      {grupper.map((grupp) => (
        <section key={grupp.bokstav} aria-labelledby={`bokstav-${grupp.bokstav}`}>
          <h2 className="sektionsrubrik begrepp-bokstav" id={`bokstav-${grupp.bokstav}`}>
            {grupp.bokstav}
          </h2>
          <ul className="begrepp-oversikt">
            {grupp.poster.map((post) => (
              <li key={post.slug}>
                <Link to={`/begrepp/${post.slug}`}>{post.begrepp}</Link>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  )
}
